import { Route, Routes } from "react-router-dom";
import { observer } from "mobx-react";
import {
    getSettingsPagePath,
    getOrganizationHelpPath,
    getNoticePagePath,
    getNoticePageLink,
} from "../Links/UrlConstructors";
import { CredentialsSettings } from "../../AccountSettings/Pages";
import AdministratorInstructions from "../../AccountSettings/Pages/Organization/Support/AdministratorInstructions";
import { NavigateInternally } from "../Components";
import { NoticePage } from "../../../modules/pages/NoticePage";

const NoUserProfileAccountSettingsRoutes = observer(() => {

    /********* Render *********/

    return (
        <Routes>
            {/* Account Section */}
            <Route path={getNoticePagePath()} element={<NoticePage />} />
            <Route path={getSettingsPagePath()} element={<CredentialsSettings />} />
            {/* Support Section */}
            <Route path={getOrganizationHelpPath()} element={<AdministratorInstructions />} />
            {/* Catch All */}
            <Route path={"/*"} element={<NavigateInternally to={getNoticePageLink()} replace />} />
        </Routes>
    );
});

export default NoUserProfileAccountSettingsRoutes;